import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const Login: React.FC = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  // Sign-in problems show here, under the button, not in an alert() (DATA-369).
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (user) navigate('/dashboard');
  }, [user, navigate]);

  const handleSuccess = async (response: any) => {
    setError(null);
    try {
      await login(response.credential);
      navigate('/dashboard');
    } catch (e: any) {
      setError(e?.response?.data?.detail || 'Sign-in failed. Please try again.');
    }
  };

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <main className="flex min-h-screen items-center justify-center bg-canvas px-4">
        <div className="w-full max-w-md rounded-2xl border border-line bg-surface p-10 text-center shadow-lg">
          <div className="mb-8">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-navy-800">
              <svg className="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7c0-2-1-3-3-3H7C5 4 4 5 4 7z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6M9 8h6M9 16h4" />
              </svg>
            </div>
            <h1 className="text-2xl font-semibold text-body">Educate Data Ingestion</h1>
            <p className="mt-2 text-sm text-muted">Sign in with your Educate account to continue</p>
          </div>

          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={() => setError('Sign-in failed. Please try again.')}
              useOneTap
            />
          </div>

          {error && (
            <p role="alert" className="mt-4 rounded-lg bg-fail-bg px-3 py-2 text-sm text-fail-fg">
              {error}
            </p>
          )}

          <p className="mt-6 text-xs text-muted">Access restricted to @experienceeducate.org accounts</p>
        </div>
      </main>
    </GoogleOAuthProvider>
  );
};

export default Login;
